export default __webpack_public_path__ + "static/media/rails-logo.ffc4b9f3.svg";